import React, { useState } from "react";
import axios from "axios";
import {
  Section,
  SectionTitle,
  Card,
  FormSection,
  SectionHeader,
  FieldGroup,
  Field,
  Label,
  Input,
  Actions,
  PrimaryButton,
  FormError,
  Info,
  FieldHelper,
  SelectStyled
} from "../styles/StyledComponents";
import ServiceTransferBanner from "./ServiceTransferBanner";

const SearchComplaint = () => {
  const [phoneNumbererror, setphoneNumbererror] = useState("");
  const [error, seterror] = useState("");
  const [selectionvalue, setselectionvalue] = useState("");
  const [selection, setselection] = useState("");
  const [selectionerror, setselectionerror] = useState("");
  const [isSearching, setIsSearching] = useState(false);

  const selectionOption = [
    { value: "ID", label: "رقم هوية الطالب" },
    { value: "Phone Number", label: "رقم الجوال" },
    { value: "Compliant Number", label: "رقم الشكوى" },
  ];

  const handleSearch = () => {
    setselectionerror("");
    setphoneNumbererror("");

    if (!selection || !selection.value) {
      setphoneNumbererror("يرجى اختيار نوع البحث أولا");
      return;
    }
    if (!selectionvalue) {
      setphoneNumbererror("يرجى إدخال القيمة ");
      return;
    }

    setIsSearching(true);
    const controller = new AbortController();
    axios(
      `https://csts.tatweertransit.com/support/ws/api/tickets/getUserTicketStatus?${encodeURIComponent(
        selection.value
      )}=${encodeURIComponent(selectionvalue)}`,
      { signal: controller.signal }
    )
      .then((res) => {
        setselectionerror(res?.data?.Data ?? "");
      })
      .catch((err) => {
        if (err.name === "CanceledError") return;
        setselectionerror("حدث خطأ أثناء البحث");
      })
      .finally(() => setIsSearching(false));
  };

  return (
    <>
      <Section>
        <ServiceTransferBanner />
        <SectionTitle>البحث عن البلاغ</SectionTitle>
        <Card style={{ pointerEvents: 'none', opacity: 0.6 }}>
        <FormSection>
          <SectionHeader>بحث في قاعدة البيانات</SectionHeader>
          <FieldGroup>
            <Field>
              <Label htmlFor="searchType" className="required">نوع البحث</Label>
              <SelectStyled
                inputId="searchType"
                classNamePrefix="rs"
                value={selection}
                options={selectionOption}
                placeholder="اختر طريقة البحث"
                onChange={(e) => setselection(e)}
              />
              <FieldHelper>اختر الطريقة التي تفضلها للبحث عن بلاغك</FieldHelper>
            </Field>

            <Field>
              <Label htmlFor="selectionvalue" className="required">قيمة البحث</Label>
              <Input
                id="selectionvalue"
                type="text"
                inputMode="numeric"
                value={selectionvalue}
                placeholder={
                  selection?.value === 'ID' ? 'أدخل رقم هوية الطالب' :
                  selection?.value === 'Phone Number' ? 'أدخل رقم الجوال' :
                  selection?.value === 'Compliant Number' ? 'أدخل رقم الشكوى' :
                  'اختر نوع البحث أولاً'
                }
                onChange={(e) => setselectionvalue(e.target.value.slice(0, 10))}
              />
              {selectionerror && <Info>{selectionerror}</Info>}
            </Field>
          </FieldGroup>

          <Actions>
            <PrimaryButton
              type="button"
              onClick={(e) => {
                e.preventDefault();
                return false;
              }}
              disabled={true}
              aria-busy={false}
              style={{ opacity: 0.5, cursor: 'not-allowed' }}
            >
              الخدمة غير متاحة
            </PrimaryButton>
          </Actions>

          {error && <FormError>{error}</FormError>}
        </FormSection>
      </Card>
    </Section>
    </>
  );
};

export default SearchComplaint;
